module.exports = __webpack_public_path__ + "img/Billy.9a1a444f.svg";